import { DEALER_TYPE_CODE } from '../constants/dealer-constants';
import { externalContentManager } from '../service/external-content';
import { myDealerService } from '../service/mydealer-service';
import { NdpsDealer } from '../types/dealer-types';

// Devuelve el KVPS priorizando el de externalContentManager y luego el de myDealerService
export const getDealerId = (): string | undefined => {
	return externalContentManager.dealerId ?? myDealerService.currentDealerId;
};

// Convierte ESP12345X -> 12345
export const sanitizeKvps = (kvps?: string): string | null => {
	if (!kvps) return null;
	return kvps.replace(/^ESP(\d+)[A-Z]$/, '$1');
};

export const dealersSummary = (dealers: NdpsDealer[]) => {
	const concessionMap = new Map<
		string,
		{
			commercialName: string;
			dealerTypes: any[];
			dealerCount: number;
			kvpsMap: Map<string, any[]>;
		}
	>();

	for (const dealer of dealers.sort((a, b) =>
		(a.VGED_CommercialName__c ?? '').localeCompare(b.VGED_CommercialName__c ?? '', 'es', {
			sensitivity: 'base',
		}),
	)) {
		const concessionCode = dealer.VGED_ConcessionDealerCode__c || '';
		const commercialName = dealer.VGED_CommercialName__c || '';
		const kvpsCode = dealer.KVPSCode__c || '';
		const dealerType = DEALER_TYPE_CODE[Number(dealer.RCY_DealerType__c || 0)];

		let concession = concessionMap.get(concessionCode);

		if (!concession) {
			concession = {
				commercialName,
				dealerTypes: [],
				dealerCount: 0,
				kvpsMap: new Map(),
			};

			concessionMap.set(concessionCode, concession);
		}

		concession.dealerCount++;
		concession.dealerTypes.push(dealerType);

		let kvpsTypes = concession.kvpsMap.get(kvpsCode);

		if (!kvpsTypes) {
			kvpsTypes = [];
			concession.kvpsMap.set(kvpsCode, kvpsTypes);
		}

		kvpsTypes.push(dealerType);
	}

	return [...concessionMap.entries()].map(([concessionCode, concession]) => {
		const hasVN = concession.dealerTypes.includes('VN');
		const hasVO = concession.dealerTypes.includes('VO');

		const typeDescription =
			hasVN && hasVO ? 'Concesiones con VN y VO' : hasVN ? 'Concesiones solo VN' : 'Concesiones solo VO';

		const description = concession.dealerCount === 1 ? `Un solo dealer. ${typeDescription}` : typeDescription;

		return `${concessionCode} ${concession.commercialName} ${description} ${[...concession.kvpsMap.entries()].map(
			([kvpsCode, dealerTypes]) => `${kvpsCode}(${[...dealerTypes].sort().join(' ')})`,
		)}`?.trim();
	});
};
